import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DebitsEffects, debitsReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([DebitsEffects]), StoreModule.forFeature(`debits`, debitsReducer)]
})
export class DebitsStateModule {}
